import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { log } from '../api';

const RouteLogger = () => {
  const location = useLocation();
  const { guestId } = useAuth();

  useEffect(() => {
    if (!guestId) return;
    log(
      guestId,
      location.pathname,
      () => {
        console.log(`user: ${guestId} navigated to: ${location.pathname}`);
      },
      (err) => {
        console.error(
          `Failed to log navigation by user: ${guestId} to: ${location.pathname}`,
          err
        );
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guestId, location]);
};

export default RouteLogger;
